<template>
    <div>
        <div class="alert alert-success">
            {{
                $t("import_tally", {
                    collections: tally["collections_created"],
                    products: tally["base_products_created"],
                    variants: tally["product_variants_created"],
                })
            }}
        </div>
        <table class="table">
            <thead>
                <tr>
                    <th scope="col">Row</th>
                    <th scope="col">Message</th>
                </tr>
            </thead>
            <tbody>
                <tr
                    v-for="(log, index) in tally.log"
                    :key="index"
                    :class="{ 'table-danger': log.type === 1 }"
                >
                    <td>{{ log.row }}</td>
                    <td>{{ log.message }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
  name: "ProductImportTally",
  props: {
    tally: Object
  }
};
</script>

<style scoped>
</style>
